import { axios } from '@/utils/request'

const api = {
  goodsOptions: '/badminapi/youhuiquan/goodsOptions',
  couponDetail: '/badminapi/youhuiquan/youhuiquanDetail',
  couponList: '/badminapi/youhuiquan/youhuiquanList',
  couponEdit: '/badminapi/youhuiquan/edit',
  couponAdd: '/badminapi/youhuiquan/add',
  couponDelete: '/badminapi/youhuiquan/youhuiquanDelete',
  setCouponAllStatus: '/badminapi/youhuiquan/setYouhuiquanAllStatus',
  getCouponUserList: '/badminapi/youhuiquan/youhuiquanUserList',
  couponSend:'/badminapi/youhuiquan/send'
}

export default api

export function getCouponList(parameter) {
  return axios({
    url: api.couponList,
    method: 'get',
    params: parameter
  })
}
export function getCouponDetail(parameter) {
  return axios({
    url: api.couponDetail,
    method: 'get',
    params: parameter
  })
}
export function getGoodsOptions(parameter) {
  return axios({
    url: api.goodsOptions,
    method: 'get',
    params: parameter
  })
}
export function editCoupon(parameter) {
  return axios({
    url: api.couponEdit,
    method: 'post',
    data: parameter
  })
}
export function addCoupon(parameter) {
  console.log('addCoupon');
  console.log(parameter);
  return axios({
    url: api.couponAdd,
    method: 'post',
    data: parameter
  })
}

export function deleteCoupon(parameter) {
  return axios({
    url: api.couponDelete,
    method: 'post',
    data: parameter
  })
}
export function setCouponAllStatus(parameter) {
  return axios({
    url: api.setCouponAllStatus,
    method: 'post',
    data: parameter
  })
}
export function getCouponUserList(parameter) {
  return axios({
    url: api.getCouponUserList,
    method: 'get',
    params: parameter
  })
}

export function sendCoupon(parameter) {
  return axios({
    url: api.couponSend,
    method: 'post',
    data: parameter
  })
}